export const APPOINTMENT_TIME_ZONE = "Asia/Kolkata";
export const APPOINTMENT_WINDOW_DAYS = 21;

export const APPOINTMENT_SLOTS = Array.from({ length: 16 }, (_, index) => {
  const totalMinutes = 11 * 60 + index * 30;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
});

export function formatAppointmentTime(time: string) {
  const [hours, minutes] = time.split(":").map(Number);
  const suffix = hours >= 12 ? "PM" : "AM";
  const displayHour = hours % 12 || 12;
  return `${displayHour}:${String(minutes).padStart(2, "0")} ${suffix}`;
}

export function getIndiaNow() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: APPOINTMENT_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).formatToParts(new Date());

  const value = (type: Intl.DateTimeFormatPartTypes) =>
    parts.find((part) => part.type === type)?.value || "00";

  return {
    date: `${value("year")}-${value("month")}-${value("day")}`,
    minutes: Number(value("hour")) * 60 + Number(value("minute")),
  };
}

export function addDays(date: string, days: number) {
  const [year, month, day] = date.split("-").map(Number);
  const value = new Date(Date.UTC(year, month - 1, day + days));
  return value.toISOString().slice(0, 10);
}

export function isBookableDate(date: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return false;
  const { date: today } = getIndiaNow();
  const firstBookableDate = addDays(today, 1);
  const finalBookableDate = addDays(firstBookableDate, APPOINTMENT_WINDOW_DAYS - 1);
  return date >= firstBookableDate && date <= finalBookableDate;
}

export function isFutureSlot(date: string, time: string) {
  const now = getIndiaNow();
  if (date > now.date) return true;
  if (date < now.date) return false;
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes > now.minutes;
}
